import useTSICallingPoints from "./useTSICallingPoints";
import useTSIDestinationCallingPointIndex from "./useTSIDestinationCallingPointIndex";
import useTSIOriginCallingPointIndex from "./useTSIOriginCallingPointIndex";
const useTSIIntermediateCallingPoints = (legId) => {
  const origin = useTSIOriginCallingPointIndex(legId);
  const destination = useTSIDestinationCallingPointIndex(legId);
  const intermediate = useTSICallingPoints(legId, origin !== void 0 ? origin + 1 : void 0, destination);
  return intermediate;
};
var useTSIIntermediateCallingPoints_default = useTSIIntermediateCallingPoints;
export {
  useTSIIntermediateCallingPoints_default as default
};
